(function () {
  'use strict';

  var SORTED_ATTR = 'data-stock-sorted';
  var DEBOUNCE_MS = 80;

  var isApplying = false;
  var pendingReorder = false;
  var availabilityCache = null;
  var availabilityHandle = null;
  var debounceTimer = null;

  function getCollectionHandle() {
    var m = window.location.pathname.match(/^\/collections\/([^/?]+)/);
    return m ? m[1] : null;
  }

  function getCurrentPage() {
    var params = new URLSearchParams(window.location.search);
    var p = parseInt(params.get('page') || '1', 10);
    return isNaN(p) || p < 1 ? 1 : p;
  }

  function getTotalPages() {
    var links = document.querySelectorAll('#ProductGridContainer .pagination a, #ProductGridContainer .page-number');
    var total = 1;
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var m = href.match(/[?&]page=(\d+)/);
      if (m) {
        var p = parseInt(m[1], 10);
        if (p > total) total = p;
      }
      var txt = (a.textContent || '').trim();
      var n = parseInt(txt, 10);
      if (!isNaN(n) && n > total) total = n;
    });
    return total;
  }

  function getProductHandle(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchAvailability(handle) {
    if (availabilityCache && availabilityHandle === handle) {
      return Promise.resolve(availabilityCache);
    }
    var map = new Map();

    function fetchPage(page) {
      var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
      return fetch(url).then(function (r) {
        if (!r.ok) return null;
        return r.json();
      }).then(function (data) {
        if (!data || !data.products || data.products.length === 0) return false;
        data.products.forEach(function (p) {
          var avail = (p.variants || []).some(function (v) { return v.available; });
          map.set(p.handle, avail);
        });
        return data.products.length === 250;
      }).catch(function () { return false; });
    }

    function loop(page) {
      if (page > 20) return;
      return fetchPage(page).then(function (more) {
        if (more) return loop(page + 1);
      });
    }

    return loop(1).then(function () {
      availabilityCache = map;
      availabilityHandle = handle;
      return map;
    });
  }

  function fetchAllPages(sectionId, totalPages) {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.set('section_id', sectionId);

    var promises = [];
    for (var p = 1; p <= totalPages; p++) {
      var pageParams = new URLSearchParams(params);
      pageParams.set('page', String(p));
      var url = window.location.pathname + '?' + pageParams.toString();
      promises.push(fetch(url).then(function (r) { return r.text(); }).catch(function () { return ''; }));
    }
    return Promise.all(promises);
  }

  function reorderGrid() {
    if (isApplying) {
      pendingReorder = true;
      return;
    }
    var handle = getCollectionHandle();
    if (!handle) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;
    if (grid.hasAttribute(SORTED_ATTR)) return;

    var totalPages = getTotalPages();
    if (totalPages <= 1) {
      grid.setAttribute(SORTED_ATTR, 'true');
      return;
    }

    var sectionId = grid.dataset.id;
    if (!sectionId) return;

    isApplying = true;
    pendingReorder = false;

    var collectionEl = grid.closest('.collection');
    if (collectionEl) collectionEl.classList.add('loading');

    Promise.all([
      fetchAvailability(handle),
      fetchAllPages(sectionId, totalPages)
    ]).then(function (results) {
      var availability = results[0];
      var pagesHtml = results[1];

      var liveGrid = document.getElementById('product-grid');
      if (!liveGrid || liveGrid !== grid) return;

      var firstDoc = new DOMParser().parseFromString(pagesHtml[0] || '', 'text/html');
      var firstItems = firstDoc.querySelectorAll('#product-grid > li');
      var perPage = firstItems.length;
      if (perPage === 0) return;

      var allCards = [];
      var seen = new Set();
      pagesHtml.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        items.forEach(function (item) {
          var h = getProductHandle(item);
          if (!h || seen.has(h)) return;
          seen.add(h);
          allCards.push({ html: item.outerHTML, handle: h });
        });
      });
      if (allCards.length === 0) return;

      var inStock = [];
      var outOfStock = [];
      allCards.forEach(function (c) {
        if (availability.get(c.handle) === false) outOfStock.push(c);
        else inStock.push(c);
      });
      var sorted = inStock.concat(outOfStock);

      var currentPage = getCurrentPage();
      var startIdx = (currentPage - 1) * perPage;
      var slice = sorted.slice(startIdx, startIdx + perPage);
      if (slice.length === 0) return;

      var currentItems = grid.querySelectorAll(':scope > li');
      var currentHandles = Array.prototype.map.call(currentItems, getProductHandle);
      var newHandles = slice.map(function (s) { return s.handle; });
      var same = currentHandles.length === newHandles.length &&
        currentHandles.every(function (h, i) { return h === newHandles[i]; });

      grid.setAttribute(SORTED_ATTR, 'true');
      if (!same) {
        grid.innerHTML = slice.map(function (s) { return s.html; }).join('');
      }
    }).catch(function (e) {
      console.warn('[stock-sort] failed:', e);
    }).then(function () {
      if (collectionEl) collectionEl.classList.remove('loading');
      isApplying = false;
      if (pendingReorder) {
        pendingReorder = false;
        scheduleReorder();
      }
    });
  }

  function scheduleReorder() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reorderGrid, DEBOUNCE_MS);
  }

  function init() {
    if (!getCollectionHandle()) return;
    scheduleReorder();

    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var observer = new MutationObserver(function () {
      if (isApplying) {
        pendingReorder = true;
        return;
      }
      var handle = getCollectionHandle();
      if (handle !== availabilityHandle) {
        availabilityCache = null;
        availabilityHandle = null;
      }
      scheduleReorder();
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
